import { Body } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

interface PaymentRowProps {
  label: string;
  value: string | number | null;
  valueColor?: "default" | "loud" | "quiet" | string;
  valueSize?: "default" | "sm" | "lg" | "xs";
  valueVariant?: "default" | "bold";
  isTotal?: boolean;
  useMonoFont?: boolean;
}

export const PaymentRow = ({
  label,
  value,
  valueColor = "loud",
  valueSize = "default",
  valueVariant = "default",
  isTotal = false,
  useMonoFont = false,
}: PaymentRowProps) => {
  return (
    <div className="flex justify-between py-3">
      <Body color="default">{label}</Body>
      {isTotal ? (
        <p
          className={cn(
            "text-right text-[18px] leading-[32px] font-semibold",
            valueColor,
          )}
        >
          {value || "-"}
        </p>
      ) : useMonoFont ? (
        <p
          className={cn(
            "text-right font-geist-mono",
            valueColor === "loud"
              ? "text-body-loud"
              : valueColor === "quiet"
                ? "text-body-quiet"
                : "text-body",
          )}
        >
          {value || "-"}
        </p>
      ) : (
        <Body
          color={valueColor as "default" | "loud" | "quiet"}
          size={valueSize}
          variant={valueVariant}
          className="text-right"
        >
          {value || "-"}
        </Body>
      )}
    </div>
  );
};
